


























































































































































import { defineComponent, computed, ref, PropType, toRefs } from '@vue/composition-api';
import _ from 'lodash-es';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';
import { useCreativeActionTypeIs, useStore } from '@tt4b/ttam-hooks';
import { AcoFormData, ACTION_TYPE, AdgroupFormData, CampaignFormData, FullNormalFormData } from '@tt4b/ttam-enums';
import { useCreativeOfflineEvents } from '../hooks/useCreativeOfflineEvents';
import { i18n } from './../../../../i18n';
import { trackEvent } from './../../../../utils/index';
import { useOfflineEventsDefaultData } from '../hooks/useOfflineEventsDefaultData';
import SelectListOperator from '@/components/common/select-list-operator/index.vue';
import TtamTrackingDataEmpty from '../tracking-data-empty.vue';

const name = 'ttam-creative-track-offline-events';

export default defineComponent({
  name,
  components: {
    SelectListOperator,
    QuestionTooltip,
    TtamTrackingDataEmpty,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    isDisabledCreative: {
      type: Boolean,
      default: false,
    },
    createMode: {
      type: String as PropType<typeof ACTION_TYPE[keyof typeof ACTION_TYPE]>,
      default: ACTION_TYPE.CREATE,
    },
    isNewTiktokEventTrack: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { state } = useStore();
    const aadvid = computed(() => state.baseInfo.value.aadvid);
    const { createMode, creativeData, adgroupData } = toRefs(props);

    const { isEdit, isCreate } = useCreativeActionTypeIs({
      createMode,
      adgroupFormData: adgroupData,
    });
    const {
      shouldRedDotShow,
      loading,
      selectedList,
      deletedEventsIds,
      offlineEventsList,
      isShowDeletedIdsPrompt,
      loadOfflineEventsList,
      clickRedDotItem: doHideRedDot,
      deletedEventsNames,
    } = useCreativeOfflineEvents({ createMode, creativeData, adgroupData });

    const { getOfflineEventsDefaultSelectedData } = useOfflineEventsDefaultData({
      createMode,
      creativeData,
      adgroupData,
    });

    const offlineEventsSelectDom = ref();

    const _trackingOfflineEventSetIds = computed(() => creativeData.value?.trackingOfflineEventSetIds || []);
    const selectedIds = computed({
      get: () => _trackingOfflineEventSetIds.value || [],
      set: val => {
        emit('change', {
          trackingOfflineEventSetIds: val || [],
        });
      },
    });

    const selectedLabel = () =>
      selectedIds.value?.length ? i18n.t('module_creative_track_offline_events_place_holder') : '';

    async function refreshSelectedList() {
      const {
        trackingOfflineEventSetIds: newTrackingOfflineEventSetIds,
        deletedIds,
        deletedNames,
      } = await getOfflineEventsDefaultSelectedData();

      if (!_.isEqual(newTrackingOfflineEventSetIds, _trackingOfflineEventSetIds.value)) {
        emit('change', {
          trackingOfflineEventSetIds: newTrackingOfflineEventSetIds,
        });
      }

      if (isEdit.value) {
        emit('change', {
          trackingOfflineEventConfig: {
            ...creativeData.value?.trackingOfflineEventConfig,
            deletedIds,
            deletedNames,
          },
        });
      }
    }

    function onChange(val, nodes, node, isChecked) {
      emit('change', {
        trackingOfflineEventSetIds: val || [],
      });
      isChecked
        ? trackEvent('select_ad_offline_tracking', { type: node?.autoTracking ? 'auto' : 'non-auto' })
        : trackEvent('delete_ad_offline_tracking', { type: node?.autoTracking ? 'auto' : 'non-auto' });
    }
    function onTreeOptionsClose() {
      // 编辑、草稿场景失去焦点，移除提示
      if (isEdit.value || isCreate.value) {
        emit('change', {
          trackingOfflineEventConfig: {
            ...creativeData.value?.trackingOfflineEventConfig,
            deletedIds: [],
            deletedNames: [],
          },
        });
      }
    }

    function onRefresh() {
      loadOfflineEventsList().then(() => {
        refreshSelectedList();
      });
      trackEvent('refresh_ad_offline_tracking');
    }

    const addNewLink = computed(() => `/i18n/events_manager/offline?aadvid=${aadvid.value}`);
    function createNew() {
      trackEvent('create_ad_offline_tracking');
      window.open(addNewLink.value);
    }

    function onTagClose(item) {
      const newIds = selectedIds.value.filter(v => v !== item.id);
      emit('change', {
        trackingOfflineEventSetIds: newIds || [],
      });
      trackEvent('delete_ad_offline_tracking', { type: item?.autoTracking ? 'auto' : 'non-auto' });
    }

    return {
      loading,
      selectedIds,
      selectedList,
      offlineEventsList,
      shouldRedDotShow,
      deletedEventsIds,
      offlineEventsSelectDom,
      isShowDeletedIdsPrompt,
      _trackingOfflineEventSetIds,
      addNewLink,
      deletedEventsNames,
      onRefresh,
      createNew,
      onChange,
      onTagClose,
      onTreeOptionsClose,
      doHideRedDot,
      selectedLabel,
      name,
    };
  },
});
